// Import model
import { FilterCustomerReviewRequest } from '../models/FilterCustomerReviewRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CustomerReviewCondition } from '../models/CustomerReviewCondition';
import { CustomerReviewFields } from '../models/CustomerReviewFields';
import { CustomerReviewIndexedFields } from '../models/CustomerReviewIndexedFields';

// Import dependency serializers (for complex types)
import { CustomerReviewConditionSerializer } from './CustomerReviewConditionSerializer';
import { CustomerReviewFieldsSerializer } from './CustomerReviewFieldsSerializer';
import { CustomerReviewIndexedFieldsSerializer } from './CustomerReviewIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCustomerReviewRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCustomerReviewRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCustomerReviewRequest instance
   */
  static deserialize(json: string): FilterCustomerReviewRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCustomerReviewRequest instance
   */
  static fromObject(obj: any): FilterCustomerReviewRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCustomerReviewRequest');
    }


    const instance: FilterCustomerReviewRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CustomerReviewIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CustomerReviewFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CustomerReviewConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCustomerReviewRequest instances
   */
  static deserializeArray(json: string): FilterCustomerReviewRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCustomerReviewRequest instance to a JSON string
   */
  static serialize(instance: FilterCustomerReviewRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCustomerReviewRequest instance to a plain object
   */
  static toObject(instance: FilterCustomerReviewRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CustomerReviewConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCustomerReviewRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCustomerReviewRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
